module.exports = __webpack_public_path__ + "media/step5_animation.54efcda3.webm";